import { Button, makeStyles } from '@fluentui/react-components';
import { Edit12Regular } from '@fluentui/react-icons';
import React from 'react';
import { useAppState } from '../context';
import { DialogContextState, useDialogActions } from '../context/dialogContext';

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    right: '0px',
    top: '0px',
    zIndex: 1,
  },
});

export default function EditButton(props: {
  onClick?: () => void;
  dialogPayload?: DialogContextState | (() => DialogContextState);
}): JSX.Element {
  const styles = useStyles();
  const appState = useAppState();
  const dialogActions = useDialogActions();

  return (
    <>
      {appState.view.inEditMode && (
        <Button
          appearance="subtle"
          className={styles.root}
          icon={<Edit12Regular />}
          onClick={
            props.onClick ??
            (() => {
              if (props.dialogPayload && typeof props.dialogPayload === 'object') {
                dialogActions.openDialog(props.dialogPayload);
              } else if (props.dialogPayload) {
                dialogActions.openDialog(props.dialogPayload());
              }
            })
          }
        ></Button>
      )}
    </>
  );
}
